import { authenticatedPollApiFetch } from "./poll-api-request";

export async function downloadPollJson(pollId, name) {
  const response = await authenticatedPollApiFetch(
    `/poll/api/v1/polls/download-json/${pollId}`
  );

  if (!response.ok) {
    throw new Error(`Poll JSON export failed: ${response.status}`);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${name || "poll"}.json`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 100);
}

window.downloadPollJson = (pollId, name) => {
  downloadPollJson(pollId, name).catch((error) => {
    console.error(error);
  });
};
